import { render } from "./OfficeDetail.vue?vue&type=template&id=5e86b79e&scoped=true"
import script from "./OfficeDetail.vue?vue&type=script&lang=js"
export * from "./OfficeDetail.vue?vue&type=script&lang=js"

import "./OfficeDetail.vue?vue&type=style&index=0&id=5e86b79e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e86b79e"]])

export default __exports__